import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

const ALL_MPMC_SUBTOPICS = [
    { name: 'Module 1 (ALL)', path: '/mpmc-m1-s1' },
    { name: 'we don\'t know the exact syllabus of module 2 we consider a review from you mentioning the syllabus', path: '/mpmc-m2-s1' },
    { name: '8051 Organization and Architecture', path: '/mpmc-m3-s1' },
    { name: 'RAM and ROM Organization', path: '/mpmc-m3-s2' },
    { name: 'Machine Cycle', path: '/mpmc-m3-s3' },
    { name: 'Addressing Modes', path: '/mpmc-m3-s4' },
    { name: 'Data Processing - Stack', path: '/mpmc-m3-s5' },
    { name: 'Arithmetic Instructions', path: '/mpmc-m3-s6' },
    { name: 'Logical Instructions', path: '/mpmc-m3-s7' },
    { name: 'Branching: Conditional and Unconditional', path: '/mpmc-m3-s8' },
    { name: 'Module Summary', path: '/mpmc-m3-s9' },
    { name: 'I/O Ports', path: '/mpmc-m4-s1' },
    { name: 'Timers & Counters', path: '/mpmc-m4-s2' },
    { name: 'Serial Communication', path: '/mpmc-m4-s3' },
    { name: 'Interrupts', path: '/mpmc-m4-s4' },
    { name: 'LCD', path: '/mpmc-m5-s1' },
    { name: 'LED', path: '/mpmc-m5-s2' },
    { name: 'KEYPAD INTERFACING', path: '/mpmc-m5-s3' },
    { name: 'ADC & DAC', path: '/mpmc-m5-s4' },
    { name: 'ARM Architecture and Processor Fundamentals', path: '/mpmc-m6-s1' },
    { name: 'ARM Addressing Modes & Instruction Set', path: '/mpmc-m7-s1' }
];

const MPMCModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_MPMC_SUBTOPICS, subjectPath = '/subject-MPMCModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_MPMC_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default MPMCModuleSubtopic;
